module.exports = __webpack_public_path__ + "media/images/icon_home-433b9d93fc1f035ec09330c2512a4879.png";